import React, { useEffect, useState} from 'react';
import {Alert, Form, message, Space, Tabs} from 'antd';
import styles from './Reports.module.scss';

import ContentAuditReport from '@components/ui/ContentAuditReport';
import NewOrder from '@components/ui/NewOrder';
import HistoryOrders from '@components/ui/HistoryOrders';
import ActionButtonsBar from '@components/ui/ActionButtonsBar';
import {LocalPersistence} from "@factories/Mutations";
import {ApiCallsFactory} from "@factories/APIcalls";
import {AuditHistory, generateReport, RequestBody} from "@ui/auditReport";
import moment from "moment/moment";

const Reports = () => {
  const [defaultTabKey] = useState<string>('1');
  const [isNewOrder, setIsNewOrder] = useState<boolean>(false);
  const [isDisabledSave, setIsDisabledSave] = useState<boolean>(true);
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState<AuditHistory[]>();
  const [status, setStatus] = useState<"default" | "success" | "failed">("default");
  const successfull = true;

  const validateFields = () => {
    form
        .validateFields()
        .then((values) => {
            if(values.hotels === "all"){
                if('only' in values){
                    delete values.only
                    values =  { ...values}
                    setIsDisabledSave(false);
                    return values
                }
                else {
                    return values
                }
            }
        })
        .catch((errorInfo) => {
            setIsDisabledSave(errorInfo.errorFields.length > 0);
        })
  };

  const onSave =  () => {
    form
        .validateFields()
        .then(async (values) => {
          console.log(values);
            let body : RequestBody = {
                supplier: values.supplier,
                contentLanguage: values.contentLanguage,
                hotels: [],

            }
            if('only' in values){
                body =  updateBody(body, {
                     hotels: values.only
                 });
            }

            generateReport(body).then((res) => {
                 if (res.result.success) {
                     form.resetFields()
                     setIsNewOrder(false)
                     setStatus("success");
                 } else {
                     message.error({
                         content: res?.error[0]?.message || 'operation failed'
                     });
                 }
            }).catch( (err) =>
                message.error({
                content: err.message || err.error[0].message
            }));
        })
        .catch((errorInfo) => setIsDisabledSave(errorInfo.errorFields.length > 0));
  }

  const updateBody = (body: RequestBody, fieldsToUpdate: Partial<RequestBody>): RequestBody => {
      return {...body, ...fieldsToUpdate}
  }

  const onCancel = () => {
      form.resetFields()
      setIsNewOrder(false);
  }

  useEffect(()=>{
          if(status === "success"){
              setTimeout(()=>{
                  setStatus("default");
              }, 3000);
          }
  },[status])
  const getDataSource  = async () =>{
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()
      const auditReport = new ApiCallsFactory(`/reports/audit`, session.token);
      let supplier: string = session.supplier;
      if(supplier.includes(",")){
         supplier =  supplier.split(",")[0];
      }
      const supplierParams = new URLSearchParams("supplier="+ supplier);
      const response: any = await auditReport.getData(supplierParams);

      if(response.result.success){
          const historyList: AuditHistory[] = response.historyList;
          historyList.forEach((audit: AuditHistory) =>{
              audit.requestedAt = moment(audit.requestedAt).format('YYYY-MM-DD hh:mm:ss').toString();
          })
          setDataSource(historyList);
      }
  };

  useEffect(()=>{
    getDataSource();
  }, [])

  const { TabPane } = Tabs;
  return (
    <>
        {
            status === "success" && (
                <Space direction="vertical" align={"center"} style={{ width: '100%', position: "absolute", top: "5px"}}>
                    <Alert message="A new Content Audit Report has been requested successfuly" type="success" showIcon  />
                </Space>
            )
        }
      <Tabs defaultActiveKey={defaultTabKey}>
        <TabPane
          tab="New Order"
          key="1"
        >
          {!isNewOrder && (
            <div
              className={styles.container}
              onClick={() => setIsNewOrder(true)}
            >
              <ContentAuditReport />
            </div>
          )}
          {isNewOrder && (
            <>
              <NewOrder
                  formData={form}
                  validateFields={validateFields} />
              <ActionButtonsBar
                onCancel={onCancel}
                onSave={onSave}
                disabledSave={isDisabledSave}
                styles={{ width: '100%' }}
                saveBtnText="Run Report"
                buttonSaveStyles={{ width: 'auto' }}
              />
            </>
          )}
        </TabPane>
        <TabPane
          tab="Order History"
          key="2"
        >
          <div style={{ padding: '40px 16px' }}>
            <HistoryOrders dataSource={dataSource} />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default Reports;
